var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import * as classNames from 'classnames';
import { Mutation, Query } from 'react-apollo';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'src/utils/common';
import { Avatar, Icon, IconButton, ListItemIcon, ListItemText, Popover, MenuItem, Input, DialogContent, Dialog, DialogTitle, } from '@material-ui/core';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import history from '../../../history';
import MobileChannelList from './MobileChannelList';
import { getTubeData } from 'src/gql/queries/getTube';
import { changeLang } from '../../../translation/store/actions';
import * as authActions from '../../../auth/store/actions/user.actions';
import { changeSearchVideo, toggleSidebar } from '../../../store/actions';
import UnsupportedDialog from 'src/components/reusable/UnsupportedDialog';
import { listChannelsQuery } from '../../../gql/listChannels';
import { getTranslation, getLanguages } from '../../../translation';
import { changeTooltipSettings } from '../../../auth/store/actions/user.actions';
import { userCommandMutation, userCommandVariables } from '../../../gql/userCommand';
var styles = function (theme) { return ({
    root: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        '@media(min-width: 1025px)': {
            display: 'none !important',
        },
    },
    seperator: {
        width: 1,
        height: 64,
        backgroundColor: theme.palette.divider,
    },
    logo: {
        paddingTop: 5,
        maxHeight: 55,
        marginLeft: -5,
    },
    hamburgerWrapper: {
        paddingLeft: 20,
        paddingRight: 5,
        '@media(max-width: 766px)': {
            marginRight: -20,
        },
    },
    hamburger: {
        cursor: 'pointer',
    },
    search: {
        border: '1px solid #c4c4c4',
        borderRadius: 5,
        margin: 10,
        padding: 0,
    },
    chatIcon: {
        padding: 0,
        minWidth: 30,
        marginLeft: -5,
        marginRight: -10,
    },
    searchPopover: {
        width: '100vw',
    },
}); };
// @ts-ignore
var MainToolbar = /** @class */ (function (_super) {
    __extends(MainToolbar, _super);
    function MainToolbar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inFeatureVideoChecked = false;
        _this.state = {
            userMenu: null,
            langMenu: null,
            searchPopover: null,
            unSupportedDialog: false,
            helpDialog: false,
            langDialog: false,
            search: '',
        };
        _this.userMenuClick = function (event) {
            _this.setState({ userMenu: event.currentTarget });
        };
        _this.userMenuClose = function () {
            _this.setState({ userMenu: null });
        };
        _this.onUnsupportedDialogClose = function () { return _this.setState({ unSupportedDialog: false }); };
        _this.handleOpenSearchPopover = function (event) {
            _this.setState({ searchPopover: event.currentTarget });
        };
        _this.searchPopoverClose = function () {
            _this.setState({ searchPopover: null });
        };
        _this.onSearchChange = function (e) { return _this.setState({ search: e.target.value }); };
        _this.onSearchPress = function (e) {
            if (e.key && e.key !== 'Enter')
                return;
            history.push("/results?search_query=" + _this.state.search.split(' ').join('+'));
        };
        _this.onOpenLangDialog = function () {
            _this.setState({ langDialog: true });
            _this.userMenuClose();
        };
        _this.onCloseLangDialog = function () {
            _this.setState({ langDialog: false });
        };
        _this.onLangClick = function (lang) { return function () {
            _this.props.changeLang(lang);
            _this.props.savePreferredLanguage(lang);
            _this.onCloseLangDialog();
        }; };
        return _this;
    }
    MainToolbar.prototype.render = function () {
        var _this = this;
        var _a = this.props, classes = _a.classes, user = _a.user, logout = _a.logout, translate = _a.translate, getTubeQuery = _a.getTubeQuery, language = _a.language;
        var _b = this.state, userMenu = _b.userMenu, searchPopover = _b.searchPopover, unSupportedDialog = _b.unSupportedDialog, search = _b.search, langDialog = _b.langDialog;
        var logo = getTubeQuery.loading || getTubeQuery.error
            ? ''
            : getTubeQuery.tube.logo
                ? getTubeQuery.tube.logo
                : '/assets/images/logo.png';
        return (React.createElement("div", { className: classNames(classes.root, 'flex flex-row') },
            React.createElement(UnsupportedDialog, { open: unSupportedDialog, url: history.location.pathname, onClose: this.onUnsupportedDialogClose }),
            React.createElement("div", { className: "flex flex-1" },
                React.createElement(Query, __assign({}, listChannelsQuery('readChannel')), function (_a) {
                    var loading = _a.loading, error = _a.error, data = _a.data;
                    // @ts-ignore
                    return !error && !!data ? React.createElement(MobileChannelList, { channels: data.channels, loading: loading }) : null;
                })),
            React.createElement(Link, { id: "home-link", to: "/home" }, Boolean(logo) && React.createElement("img", { className: classes.logo, src: logo, alt: "logo" })),
            React.createElement("div", { className: "flex items-center pr-16" },
                React.createElement(IconButton, { id: "search-btn", className: "w-40 h-64", onClick: this.handleOpenSearchPopover },
                    React.createElement(Icon, { style: { fontSize: 30 } }, "search")),
                React.createElement("div", { id: "user-menu", className: "cursor-pointer ml-8", onClick: this.userMenuClick }, user.data.photoUrl ? (React.createElement(Avatar, { className: "", alt: "user photo", src: user.data.photoUrl })) : user.data.displayName ? (React.createElement(Avatar, { className: "" }, user.data.displayName[0])) : user.email ? (React.createElement(Avatar, { className: "" }, user.email[0])) : null),
                React.createElement(Popover, { open: Boolean(searchPopover), anchorEl: searchPopover, onClose: this.searchPopoverClose, anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    }, transformOrigin: {
                        vertical: 'top',
                        horizontal: 'center',
                    }, classes: {
                        paper: classes.searchPopover,
                    } },
                    React.createElement("div", { className: classNames(classes.search, 'flex justify-center items-center') },
                        React.createElement(Input, { id: "search", 
                            // @ts-ignore
                            placeholder: translate('search'), className: "pl-16 w-full", disableUnderline: true, value: search, onChange: this.onSearchChange, onKeyPress: this.onSearchPress }),
                        React.createElement(IconButton, { id: "search-btn", className: "w-44 h-44 pr-16", onClick: this.onSearchPress },
                            React.createElement(Icon, null, "search")))),
                React.createElement(Popover, { open: Boolean(userMenu), anchorEl: userMenu, onClose: this.userMenuClose, anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    }, transformOrigin: {
                        vertical: 'top',
                        horizontal: 'center',
                    }, classes: {
                        paper: 'py-8',
                    } },
                    React.createElement(MenuItem, { id: "language-select", onClick: this.onOpenLangDialog },
                        React.createElement(ListItemIcon, null,
                            React.createElement(Icon, null, "language")),
                        React.createElement(ListItemText, { className: "pl-0", primary: translate(language) })),
                    React.createElement(MenuItem, { id: "logout-link", onClick: function () {
                            logout();
                            _this.userMenuClose();
                        } },
                        React.createElement(ListItemIcon, null,
                            React.createElement(Icon, null, "exit_to_app")),
                        React.createElement(ListItemText, { className: "pl-0", primary: translate('logout') }))),
                React.createElement(Dialog, { onClose: this.onCloseLangDialog, open: langDialog },
                    React.createElement(DialogTitle, null, translate('select-language')),
                    React.createElement(DialogContent, null, getLanguages().map(function (lang) { return (React.createElement(MenuItem, { id: "lang-" + lang, key: lang, onClick: _this.onLangClick(lang) },
                        React.createElement(ListItemText, { className: "pl-0", primary: translate(lang) }))); }))))));
    };
    MainToolbar = __decorate([
        withStyles(styles, { withTheme: true })
    ], MainToolbar);
    return MainToolbar;
}(React.PureComponent));
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        logout: authActions.logoutUser,
        changeSearchVideo: changeSearchVideo,
        changeLang: changeLang,
        toggleSidebar: toggleSidebar,
        changeTooltipSettings: changeTooltipSettings,
    }, dispatch);
}
function mapStateToProps(_a) {
    var auth = _a.auth, translation = _a.translation, channel = _a.channel, sidebar = _a.sidebar;
    return {
        user: auth.user,
        translate: getTranslation(translation.lang),
        language: translation.lang,
        channelId: channel.currentChannel,
        sidebarStatus: sidebar.status,
        tooltipDisabled: auth.user.settings.tooltipDisabled,
    };
}
export default (function (props) {
    var Comp = compose(getTubeData(), connect(mapStateToProps, mapDispatchToProps))(MainToolbar);
    return (React.createElement(Mutation, __assign({}, userCommandMutation()), function (userCommandReq) {
        return (React.createElement(Comp, __assign({}, props, { savePreferredLanguage: function (language) {
                return userCommandReq(userCommandVariables({
                    type: 'updatePreferredLanguage',
                    payload: { language: language },
                }));
            } })));
    }));
});



//////////////////
// WEBPACK FOOTER
// ./src/components/layouts/Main/MobileToolbar.tsx
// module id = 2046
// module chunks = 81